import React, { Component } from 'react';
import { Row, Table, Input, Label } from 'reactstrap';
import 'bootstrap/dist/css/bootstrap.css';


class CustomerManagement extends Component {
    constructor(props) {
        super(props);

        this.activeServices = [];

        this.state = {
            data: [],
        };
        this.headers = [
            { display: 'Name', accessors: ['name'] },
            { display: 'Team', accessors: ['team'] },
            { display: 'Account Owner', accessors: ['primaryFirstName', 'primaryLastName'] },
            { display: 'Processor', accessors: ['processorFirstName', 'processorLastName'] },
            { display: 'Backup', accessors: ['secondaryFirstName', 'secondaryLastName'] },
        ]
    }

    componentDidMount() {
        this.props.log('CustomerManagement.js/componentDidMount');
        this.onSubmit();
    }

    onSubmit = () => {
        this.props.log('CustomerManagement.js/onSubmit');
        fetch('/api/reports/CustomerManagementReport', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + this.props.clientToken
            },
            body: JSON.stringify([
            ])
        })
            .then(results => results.json())
            .then(results => {
                if (results.success) {
                    let sel = {};
                    results.data.forEach(row => {
                        row.services = JSON.parse(row.services);
                        row.services.forEach(parentService => {
                            if (parentService.childServices != null && this.activeServices.findIndex(service => service.serviceId === parentService.serviceId) === -1) {
                                this.activeServices.push({ serviceId: parentService.serviceId, name: parentService.name });
                                sel["show" + parentService.serviceId] = true;
                            }
                        })
                        let activeServiceArr = [];
                        if (row.info !== '' && row.info != null) {
                            row.info = JSON.parse(row.info);
                            Object.keys(row.info).forEach(category => {
                                if (category !== "contacts" && category !== "customerDetails") {
                                    if (row.info[category].findIndex(item => item.active === true || item.active == null) > -1) {
                                        activeServiceArr.push({[category]: true});
                                    } else {
                                        activeServiceArr.push({[category]: false});
                                    }
                                }
                            })
                        }
                        row.activeServices = activeServiceArr;
                    })
                    this.activeServices.sort();
                    this.setState({
                        data: results.data,
                        ...sel
                    }, () => this.getCSVdata());
                } else {
                    this.props.addToast('Unable to download report.', 5, 'danger');
                }
            })
        .catch(() => {
            this.props.addToast('An error has occurred.', 5, 'danger');
        })
    }

    getCSVdata = () => {
        this.props.log('CustomerManagement.js/getCSVdata');
        let retArray = [['Name', 'Team', 'Account Owner', 'Processor', 'Backup']];
        this.state.data.filter(row => {
            let show = false;
            row.services.forEach(service => {
                if (service.childServices != null && this.state["show" + service.serviceId]) show = true;
            })
            return show;
        }).forEach(row => {
            let rowArray = [];
            this.headers.forEach(field => {
                rowArray.push(field.accessors.map(accessor => row[accessor]).join(' ').trim());
            })
            retArray.push(rowArray);
        })
        this.props.passData(retArray, "customer-management_" + this.state.data[0].name.replace(' ', '-'));
    }

    onlySelect = (service) => {
        this.props.log('CustomerManagement.js/onlySelect (service)', service);
        let sel = { ...this.state };
        Object.keys(this.state).filter(key => key.indexOf("show") === 0).forEach(key => {
            sel[key] = false;
        });
        sel[service] = true;
        this.setState(sel, () => this.getCSVdata())
    }

    render() {
        this.props.info('CustomerManagement.js/render');
        return (
            <>
                <Row className="text-left adminRow font-weight-bold">
                    {this.activeServices.map(service => (
                        <div key={service.serviceId} className="px-4 pull-left">
                            <Label><Input
                                type="checkbox"
                                name={"show" + service.serviceId}
                                checked={this.props.isFieldNull(this.state["show" + service.serviceId], true)}
                                onChange={() => this.setState((prevState) => {
                                    let sel = prevState;
                                    sel["show" + service.serviceId] = !this.state["show" + service.serviceId];
                                    return sel;
                                }, () => this.getCSVdata())}
                            /> {service.name}</Label><span onClick={() => this.onlySelect("show" + service.serviceId)} className="pull-left px-2 onlySelect">Only</span>
                        </div>
                    ))}
                </Row>
                {this.state.data.length > 0 ?
                    <>
                        <Row><Table>
                            <thead>
                                <tr>
                                    <th>Name</th>
                                    <th>Team</th>
                                    <th>Account Owner</th>
                                    <th>Processor</th>
                                    <th>Secondary Contact</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.data.filter(row => {
                                    let show = false;
                                    row.services.forEach(service => {
                                        if (service.childServices != null && this.state["show" + service.serviceId]) {
                                            service.childServices.forEach(child => {
                                                if (row.activeServices.findIndex(item => item[Object.keys(item)[0]] && Object.keys(item)[0] === child.section) > -1 || row.info == null) show = true;
                                            })
                                            // show = true;
                                        }
                                    })
                                    return show;
                                }).map(row => (
                                    <tr key={row.clientId}>
                                        <td>{row.name}</td>
                                        <td>{row.team}</td>
                                        <td>{row.primaryFirstName} {row.primaryLastName}</td>
                                        <td>{row.processorFirstName} {row.processorLastName}</td>
                                        <td>{row.secondaryFirstName} {row.secondaryLastName}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </Table></Row>
                    </>
                    : <>No results</>}
            </>
        );

    }
}

export default CustomerManagement;
